import request from '@/utils/request';

// 获取列表
export function GetPage(params) {
  return request({
    url: '/api/user/authentication/page',
    method: 'GET',
    params: params
  });
}

// 获取信息
export function GetAuthentication() {
  return request({
    url: '/api/user/authentication/detail',
    method: 'GET',
  });
}


// 保存
export function Save(data) {
  return request({
    url: '/api/user/authentication/save',
    method: 'POST',
    data
  });
}

// 编辑
export function Edit(data) {
  return request({
    url: '/api/user/authentication/edit',
    method: 'POST',
    data
  });
}

// 企业名称搜索
export function GetNameList(params) {
  return request({
    url: '/api/user/bill/getSelect',
    method: 'GET',
    params: params
  });
}

// 详情
export function Detail(params) {
  return request({
    url: '/api/user/authentication/detail',
    method: 'GET',
    params: params
  });
}

// 获取登录用户信息
export function GetUserInfo() {
  return request({
    url: '/api/user/info/getInfo',
    method: 'GET',
  });
}
